import { render, staticRenderFns } from "./user-details.vue?vue&type=template&id=f9695834&scoped=true"
import script from "./user-details.vue?vue&type=script&lang=js"
export * from "./user-details.vue?vue&type=script&lang=js"
import style0 from "./user-details.vue?vue&type=style&index=0&id=f9695834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9695834",
  null
  
)

export default component.exports